/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, arrayFrom } from '../../twd'

export default ({holdings, account}) => {

    let acctHoldings = arrayFrom(holdings)
        .filter( r => r.acctNo === account)

    if (acctHoldings.length===0) {
        return <div
            data-name="holdings-modal-not-found"
            className="text-center">
            <div className="vertical-offset-xs">
            <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
            </div>
            <div className="vertical-offset-xs">
            <div className="small-header vertical-offset-xxs">No holdings found.</div>
            </div>
        </div>
    }

    return <div className="table-responsive" style={{maxWidth:'100%', overflowY:'auto'}}>
    <table data-name="holdings-modal-table" className="table table-striped" >
    <thead>
    <tr>
        <th style={{maxWidth:'300px'}}>Issuer</th>
        <th className="text-right">Qty</th>
        <th className="text-right">Coupon</th>
        <th className="text-right">Maturity</th>
        <th className="text-right">Action</th>
    </tr>
    </thead>

    <tbody>{
        acctHoldings
        .map( (r,i) => {
            return <tr
                data-name="holdings-modal-row"
                key={i}>
            <td
                style={{maxWidth:'300px'}}
                className="text-left text-truncate">{fmt.issuer({
                issuer: r.issue,
                showBackLink: 'N',
                cusip: r.cusip,
            })}</td>
            <td className="text-right">{fmt.qty(r.qty)}</td>
            <td className="text-right">{fmt.cpn(r.coupon)}</td>
            <td className="text-right" style={{overflow:'visible'}}>{fmt.mdy(r.maturity)}</td>
            <td className="text-right">{fmt.sell({
                cusip: r.cusip,
                acctNo: r.acctNo,
                qty: r.qty,
                sourceAction: 'H',
                style:{padding:'3px'}})}</td>
            </tr>
        })
    }</tbody>

    </table>
    </div>
}
